<svg
  [attr.width]="size"
  [attr.height]="size"
  fill="none"
  viewBox="0 0 16 16"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M6.78033 1.96967C7.07322 2.26256 7.07322 2.73744 6.78033 3.03033L3.81066 6H10.25C12.8733 6 15 8.12663 15 10.75V13.25C15 13.6642 14.6642 14 14.25 14C13.8358 14 13.5 13.6642 13.5 13.25V10.75C13.5 8.95507 12.0449 7.5 10.25 7.5H3.81066L6.78033 10.4697C7.07322 10.7626 7.07322 11.2374 6.78033 11.5303C6.48744 11.8232 6.01256 11.8232 5.71967 11.5303L1.46967 7.28033C1.17678 6.98744 1.17678 6.51256 1.46967 6.21967L5.71967 1.96967C6.01256 1.67678 6.48744 1.67678 6.78033 1.96967Z"
    fill="currentColor"
  />
</svg>
